import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="border-t border-olive-deep bg-olive-deep text-cream/80">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
        <div>
          <img src="/logo.png" alt="Fresh Start Furnishings" className="h-16 w-auto rounded-lg bg-cream p-1" />
          <p className="mt-4 font-script text-2xl text-gold">A Fresh Start. A New Home. A New Beginning.</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-cream/60">
            A pilot program helping women and families turn empty houses into homes across Glendale and the West Valley.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Explore</p>
          <ul className="mt-4 space-y-2 text-sm">
            {[
              ["/donate-items", "Donate Items"],
              ["/shop", "Shop Affordable Furniture"],
              ["/apply-to-shop", "Apply to Shop"],
              ["/support", "Support the Pilot Program"],
              ["/how-it-works", "How It Works"],
              ["/what-we-accept", "What We Accept"],
              ["/partners", "Partners"],
              ["/volunteers", "Volunteer"],
              ["/service-area", "Service Area"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-${label.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="transition-colors hover:text-gold">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Reach Us</p>
          <a
            data-testid="footer-email-link"
            href="mailto:freshstartfurnishings@yahoo.com"
            className="mt-4 flex items-center gap-2 text-sm transition-colors hover:text-gold"
          >
            <Mail className="h-4 w-4 shrink-0" /> freshstartfurnishings@yahoo.com
          </a>
          <p className="mt-4 flex items-start gap-2 text-sm text-cream/60">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> Serving Glendale, the West Valley &amp; Surrounding Areas, Arizona
          </p>
          <Link to="/admin" data-testid="footer-admin-link" className="mt-6 inline-block text-xs text-cream/40 transition-colors hover:text-gold">
            Admin Login
          </Link>
        </div>
      </div>
      <div className="border-t border-cream/10 py-5 text-center text-xs text-cream/40">
        © {new Date().getFullYear()} Fresh Start Furnishings · A community pilot program · Glendale, Arizona
      </div>
    </footer>
  );
}
